'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

var path = require('path')
if(process.env.type === 'pdt'){
    var url = require('./url.cof.pdt')
}else{
    var url = require('./url.cof')
}

module.exports = {
    dev: {

        // Paths
        assetsSubDirectory: 'static',
        assetsPublicPath: '/',
        proxyTable: {},

        // Various Dev Server settings
        host: 'localhost', // can be overwritten by process.env.HOST
        port: 8089, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
        autoOpenBrowser: true,
        errorOverlay: true,
        notifyOnErrors: true,
        poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-


        /**
         * Source Maps
         */

        // https://webpack.js.org/configuration/devtool/#development
        devtool: 'cheap-module-eval-source-map',

        // If you have problems debugging vue-files in devtools,
        // set this to false - it *may* help
        // https://vue-loader.vuejs.org/en/options.html#cachebusting
        cacheBusting: true,

        cssSourceMap: true,
        ajaxUrl: url.dev.ajaxUrl,
        ajaxUrl1: url.dev.ajaxUrl1,
        ajaxUrl2: url.dev.ajaxUrl2,
        ajaxUrl3: url.dev.ajaxUrl3,
//      ajaxUrl4: url.dev.ajaxUrl4,
        ajaxUrl5: url.dev.ajaxUrl5,
        accountBaseUrl: url.dev.accountBaseUrl,
        orderUrl: url.dev.orderUrl,
        jumpDeal: url.dev.jumpDeal,
        getDealList:url.dev.getDealList,
        landUrl:url.dev.landUrl,
        stockUrl:url.dev.stockUrl,
        currentUrl:url.dev.currentUrl,
        checkDownload:url.dev.checkDownload,
        bindTelUrl:url.dev.bindTelUrl,
        domainUrl:url.dev.domainUrl
    },

    build: {
        // Template for index.html
        index: path.resolve(__dirname, '../dist/index.html'),

        // Paths
        assetsRoot: path.resolve(__dirname, '../dist'),
        assetsSubDirectory: 'static',
        assetsPublicPath: '/',

        /**
         * Source Maps
         */

        productionSourceMap: true,
        // https://webpack.js.org/configuration/devtool/#production
        devtool: '#source-map',

        // Gzip off by default as many popular static hosts such as
        // Surge or Netlify already gzip all static assets for you.
        // Before setting to `true`, make sure to:
        // npm install --save-dev compression-webpack-plugin
        productionGzip: true,
        productionGzipExtensions: ['js', 'css'],

        // Run the build command with an extra argument to
        // View the bundle analyzer report after build finishes:
        // `npm run build --report`
        // Set to `true` or `false` to always turn it on or off
        bundleAnalyzerReport: process.env.npm_config_report,

        ajaxUrl: url.uat.ajaxUrl,
        ajaxUrl1: url.uat.ajaxUrl1,
        ajaxUrl2: url.uat.ajaxUrl2,
        ajaxUrl3: url.uat.ajaxUrl3,
//      ajaxUrl4: url.uat.ajaxUrl4,
        ajaxUrl5: url.uat.ajaxUrl5,
        accountBaseUrl: url.uat.accountBaseUrl,
        orderUrl: url.uat.orderUrl,
        jumpDeal: url.uat.jumpDeal,
        getDealList:url.uat.getDealList,
        landUrl:url.uat.landUrl,
        stockUrl:url.uat.stockUrl,
        currentUrl:url.uat.currentUrl,
        checkDownload:url.uat.checkDownload,
        bindTelUrl:url.uat.bindTelUrl,
        domainUrl:url.uat.domainUrl
    },
    pdt: {
        ajaxUrl: url.pdt.ajaxUrl,
        ajaxUrl1: url.pdt.ajaxUrl1,
        ajaxUrl2: url.pdt.ajaxUrl2,
        ajaxUrl3: url.pdt.ajaxUrl3,
//      ajaxUrl4: url.pdt.ajaxUrl4,
        ajaxUrl5: url.pdt.ajaxUrl5,
        accountBaseUrl: url.pdt.accountBaseUrl,
        orderUrl: url.pdt.orderUrl,
        jumpDeal: url.pdt.jumpDeal,
        getDealList:url.pdt.getDealList,
        landUrl:url.pdt.landUrl,
        stockUrl:url.pdt.stockUrl,
        currentUrl:url.pdt.currentUrl,
        checkDownload:url.pdt.checkDownload,
        bindTelUrl:url.pdt.bindTelUrl,
        domainUrl:url.pdt.domainUrl
    }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41